
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/openSourceLicenses.html",
      function () {
        return require("private-next-pages/openSourceLicenses.html.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/openSourceLicenses.html"])
      });
    }
  